<template>
  <DonutChart
      :title="'En İyi Satış'"
      :description="'Ürün bazlı çok satan ürünler'"
      :donutChartOptions="bestSellStocksDataChartOptions"
      :loading="bestSellStocksDataLoading"
  >
    <template>
      <v-select
          v-model="StockCodeFilterValue"
          :items="[
                      {value: 1, text: 'Grup Kodu'},
                      {value: 2, text: 'KOD 1'},
                      {value: 3, text: 'KOD 2'},
                      {value: 4, text: 'KOD 3'},
                      {value: 5, text: 'KOD 4'},
                      {value: 6, text: 'KOD 5'}

                    ]"
          style="width:100px;margin: 0 3px"
          item-text="text"
          item-value="value"
          hide-details
          dense
          solo
          @change="_fetchBestStockList"
      >
      </v-select>
      <v-select
          v-model="timePeriodFilterValue"
          :items="[
              {value: 5, text: 'Tarih Aralığı'},
              {value: 4, text: 'Yıllık'},
              {value: 3, text: 'Aylık'},
              {value: 2, text: 'Haftalık'},
              {value: 1, text: 'Günlük'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          hide-details
          solo
          dense
          @change="timePeriodFilterValue !== 5  ? _fetchBestStockList : null"
      >

      </v-select>
      <div v-if="timePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="dateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeStartFilterValue"
              locale="tr"
              :max="dateRangeEndFilterValue ? dateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="dateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeEndFilterValue"
              locale="tr"
              :min="dateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchBestStockList"
          >
            FİLTRELE
          </v-btn>
        </div>
      </div>
    </template>
  </DonutChart>
</template>

<script>

import DonutChart from "@/components/shared/apex-charts/DonutChart";
import {numberConverter} from "../../../../helpers";
import {mapState, mapActions} from "vuex";
import {formattedDate} from "@/momentHelper";

export default {
  name: "EnIyiSatilanUrunlerDonut",
  components: {
    DonutChart
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed:{
    ...mapState("auth",["user"])
  },
  mounted(){
    this._fetchBestStockList()
  },
  data(){
    return {
      bestSellStocksDataChartOptions: {
        series: [],
        chartOptions: {
          noData: {
            text: "Aradığınız Kriterde En İyi Satış Verisi Bulunamamıştır",
            align: "center",
            verticalAlign: "middle",
          },
          labels: [],
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '12px',
            offsetX: 0
          },
          responsive: [{
            breakpoint: 1500,
            options: {
              chart: {
                height: 600
              },
              legend: {
                show: true,
                position: 'bottom',
              },
            }
          }],
          tooltip: {
            y:{
              formatter: function (val){
                return val
              }
            }

          }
        }
      },
      giroAnalysisData: null,
      bestSellStocksDataLoading: true,
      StockCodeFilterValue: 1,
      timePeriodFilterValue: 4,
      dateRangeStartFilterValue: null,
      dateRangeEndFilterValue: null,
    }
  },
  methods:{
    formattedDate,
    ...mapActions("dashboard", [
      "fetchGiroAnalysisReport"
    ]),
    numberConverter,
    _fetchBestStockList(){
      this.bestSellStocksDataLoading = true;
      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.timePeriodFilterValue === "" || this.timePeriodFilterValue == null)) && {DateType: this.timePeriodFilterValue},
          ...(!(this.StockCodeFilterValue === "" || this.StockCodeFilterValue == null)) && {CodeType: this.StockCodeFilterValue}
        }
      };

      if (this.timePeriodFilterValue === 5) {
        requestData.body.startDate = this.dateRangeStartFilterValue;
        requestData.body.endDate = this.dateRangeEndFilterValue;
      }
      this.fetchGiroAnalysisReport(requestData).then((result) => {
        if(result && result.data.success)
        {
          this.bestSellStocksDataChartOptions.series = [];
          this.bestSellStocksDataChartOptions.chartOptions.labels = [];
          let resultArray = result.data.data;
          for (let i = 0; i < resultArray.length; i++) {
            this.bestSellStocksDataChartOptions.series.push(resultArray[i].salesAmount)
            this.bestSellStocksDataChartOptions.chartOptions.labels.push(resultArray[i].groupName)
          }
          this.bestSellStocksDataChartOptions.chartOptions.tooltip.y.formatter = (val) => {
            return this.numberConverter(val, "TRY");
          }
        }
        else {
          this.bestSellStocksDataChartOptions.series = [];
          this.bestSellStocksDataChartOptions.chartOptions.labels = [];
        }
        this.bestSellStocksDataLoading = false;
      }).catch(error => {
        error
        this.bestSellStocksDataChartOptions.series = [];
        this.bestSellStocksDataChartOptions.chartOptions.labels = [];
        this.bestSellStocksDataLoading = false;
      })
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchBestStockList()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchBestStockList()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchBestStockList()
    },
    timePeriodFilterValue(newVal){
      newVal;
      this._fetchBestStockList()
    },
  }
}
</script>

<style scoped>

</style>